module.exports = __webpack_public_path__ + "static/media/image2.bf0f55c0.png";